export default function throttle(f, ms) {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);

    return new Promise(resolve => {
      timer = setTimeout(() => {
        resolve(f(...args));
      }, ms);
    });
  };
}



// WEBPACK FOOTER //
// ./app/lib/throttle.js